import { FullConfig } from "../config"
import { MapperOptions } from "./types"

const defaultOptions: MapperOptions = {
    filterRangeSeparator: "~"
}

export function createMapperOptions(config: FullConfig) {
    if (typeof config.compressUrlParameters !== "object") {
        return defaultOptions
    }

    return {
        ...defaultOptions,
        ...config.compressUrlParameters
    }
}

export function createMockMapperOptions(overrides: Partial<MapperOptions> = {}) {
    return {
        ...defaultOptions,
        ...overrides
    }
}
